
import React from 'react';
import { Lead, LeadStatus, Task } from '@/types/lead';
import LeadStatusCard from './LeadStatusCard';
import LeadSuccessMetricsCard from './LeadSuccessMetricsCard';
import TaskNotifications from './TaskNotifications';
import LeadScoreCard from './LeadScoreCard';
import { useLeadScore } from '@/hooks/useLeadScore';

interface BusinessSidebarProps {
  lead: Lead;
  tasks: Task[];
  setActiveTab: (tab: string) => void;
  onStatusChange: (status: LeadStatus) => Promise<void>;
  onOpenAddDocument: () => void;
}

const BusinessSidebar: React.FC<BusinessSidebarProps> = ({
  lead,
  tasks,
  setActiveTab,
  onStatusChange,
  onOpenAddDocument
}) => {
  const {
    leadScore,
    isLoading,
    isCalculating,
    recalculateScore
  } = useLeadScore(lead.id);

  return (
    <div className="space-y-4">
      <LeadStatusCard 
        leadId={lead.id} 
        currentStatus={lead.status as LeadStatus} 
        onStatusChange={onStatusChange} 
        lastUpdated={lead.updatedAt}
        className="border-border/40 shadow-sm"
      />
      
      <LeadScoreCard 
        leadScore={leadScore}
        isLoading={isLoading}
        isCalculating={isCalculating}
        onRecalculate={recalculateScore}
        className="border-border/40 shadow-sm"
      />
      
      <TaskNotifications 
        tasks={tasks}
        setActiveTab={setActiveTab}
        className="border-border/40 shadow-sm"
      />
      
      <LeadSuccessMetricsCard 
        leadStatus={lead.status as LeadStatus}
        timeInStatus={7}
        companySuccessRate={65}
        industrySuccessRate={58}
        className="border-border/40 shadow-sm"
      />
    </div>
  );
};

export default BusinessSidebar;
